<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Spare Parts  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/igrn/index"> Manage GRN </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" :to="'/igrn/update?id='+detail.GD_idGrn"> {{ detail.G_grn_num}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update   </h6>
    <h6 class="custom-maintitle mb-2"><b>Update GRN:{{ detail.G_grn_num }}</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveCrm()" >







    <div class="row">
        <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">Product Code</label>
            <input  v-model="detail.P_code" style="font-size: small;" class="form-control" required disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">	
Product Description</label>
            <input  v-model="detail.P_description" style="font-size: small;" class="form-control" required disabled>
    
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">	
	
                Received Qty</label>
            <input @input="fullPrice()"  v-model="detail.GD_received_qty" style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">	
	Unit Cost (Rs)</label>
            <input @input="fullPrice()"  type="number" v-model="detail.GD_unit_price" step="0.01" style="font-size: small;" class="form-control" >
    </div>
  </div>
 
  
  

</div>

<div class="row">
        <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">Total Cost (Rs)</label>
            <input  v-model="detail.full_price" style="font-size: small;" class="form-control" required disabled>
    </div>
  </div>
  </div>






  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button :disabled="isButtonDisabled" type="submit" class="mr-1 btn custom-btn btn-primary  mb-5 font-size_def">Update</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        'idgrndetail':this.$route.query.id,

        detail:{},
       
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadContact(this.idgrndetail)

      
    },
   
methods : {

    fullPrice(){
this.detail.full_price = this.detail.GD_received_qty * this.detail.GD_unit_price;
    },

  async loadContact(id) {
    
    try {
      const { data} = await  axios.get('/igrn/loadupdatedetail?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.detail = data.detail;
     
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async SaveCrm() {
  
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/igrn/updatedetail?id='+this.idgrndetail,{userid:this.userid,detail:this.detail},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/igrn/update?id='+this.detail.GD_idGrn);
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
 

  


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>